import React, { FC, ReactNode } from "react";

export interface NoticeBarProps {
  /** Omitted where the note is a single sentence with nothing to head it. */
  title?: ReactNode;
  body: ReactNode;
  /** Defaults to the circled "i". Pass a glyph for the other variants. */
  icon?: ReactNode;
  className?: string;
}

/**
 * The cream bar with a gold rule down its left edge — the reference's standing
 * note, used for accepted documents, the inventory disclaimer and the signature
 * instruction. The gold left border is what marks it as guidance rather than a
 * validation message.
 */
const NoticeBar: FC<NoticeBarProps> = ({
  title,
  body,
  icon,
  className = "",
}) => (
  <div
    className={`flex items-center gap-[13px] border-l-[3px] border-gold bg-cream px-4 py-[13px] ${className}`}
  >
    <span className="flex-none text-gold">
      {icon || (
        <span
          className="grid h-[23px] w-[23px] place-items-center rounded-full border border-gold font-serif text-[13px] font-bold text-[#9e783f]"
          aria-hidden="true"
        >
          i
        </span>
      )}
    </span>

    <div className="min-w-0">
      {title && (
        <p className="text-[12px] font-semibold leading-[1.55] text-navy min-[760px]:text-[13px]">
          {title}
        </p>
      )}
      <p className="text-[13px] leading-[1.55] text-[#67727c] min-[760px]:text-[13px]">
        {body}
      </p>
    </div>
  </div>
);

export default NoticeBar;
